import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function leadChecklistReducer(state = initialState.leadChecklistData, action) {
  switch (action.type) {
    case types.LOAD_LEAD_CHECKLIST_DATA_SUCCESS:
      return action.leadChecklistData;
    default:
      return state;
  }
}
